var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnimal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.42 41.412c9.067 0 16.418-7.352 16.418-16.42 0-9.068-7.35-16.419-16.419-16.419C8.351 8.573 1 15.924 1 24.993c0 9.067 7.351 16.419 16.42 16.419z",
    fill: "#CE9C71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.724 9.051C9.074 5.7 1.849-.23 2.142 2.87l.679 16.165 9.903-9.983z",
    fill: "#F5BC89",
    stroke: "#CE9C71",
    strokeWidth: 3.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.52 24.628c0 8.955-8.396 14.225-16.214 14.225-6.662 0-14.03-5.37-14.03-14.751 0-8.242 8.43-15.687 14.03-15.687 8.954 0 16.213 7.259 16.213 16.213z",
    fill: "#DAA87C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.174 22.93c-1.224.118-3.884-.455-5.919-.123-1.074.175-1.837-1.552-.085-2.103 1.363-.27 4.555-.746 6.424-.488 2.337.323.804 2.594-.42 2.713z",
    fill: "#EDB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.825 22.93c1.224.118 3.884-.455 5.919-.123 1.075.175 1.837-1.552.085-2.103-1.363-.27-4.555-.746-6.424-.488-2.337.323-.804 2.594.42 2.713z",
    fill: "#fff",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.465 22.595c.207.204.412.435.58.675.411.587.086 1.3-.457 1.767-.34.293-.752.5-1.197.562-.738.102-1.664.121-2.361-.427-.695-.545-1.21-1.448-1.21-2.33 0-.118.249-.456 1.241-.868.195-.104.77-.242 1.732-.148a2.753 2.753 0 0 1 1.672.769zM23.99 22.595a5.042 5.042 0 0 0-.58.675c-.412.587-.087 1.3.456 1.767.341.293.752.5 1.197.562.738.102 1.664.121 2.361-.427.695-.545 1.21-1.448 1.21-2.33 0-.118-.248-.456-1.241-.868-.195-.104-.77-.242-1.732-.148a2.753 2.753 0 0 0-1.671.769z",
    fill: "#1F1E1E",
    stroke: "#1F1E1E",
    strokeWidth: 1.479
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.43 24.96c.418.615 2.245 1.017 3.189-.654.29-.889-.1-1.193-.68-1.836-.641-.71-2.598-1.33-2.698-.257-.126 1.341-.231 2.13.188 2.746zM26.06 24.96c-.42.615-2.246 1.017-3.19-.654-.29-.889.1-1.193.68-1.836.641-.71 2.598-1.33 2.698-.257.126 1.341.231 2.13-.188 2.746z",
    fill: "#343030",
    stroke: "#343030",
    strokeWidth: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.976 38.188h7.96c.093 4.362-.835 6.558-4.002 6.443-3.167-.115-3.928-2.212-3.958-6.443z",
    fill: "#FC5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.108 24.28c.607 0 1.099-.453 1.099-1.012 0-.558-.492-1.01-1.1-1.01-.606 0-1.098.452-1.098 1.01 0 .559.492 1.012 1.099 1.012zM24.4 24.28c.608 0 1.1-.453 1.1-1.012 0-.558-.492-1.01-1.1-1.01-.606 0-1.098.452-1.098 1.01 0 .559.492 1.012 1.099 1.012z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.941 36.507c.941 2.183 5.01 5.227 8.592 3.36 3.704 1.76 7.131-1.422 8.127-3.36.997-1.938-.213-6.303-1.21-7.946-.626-1.707-5.026-2.04-6.917-2.04-2.077 0-6.453.408-7.343 2.04-.778 1.646-2.19 5.764-1.249 7.946z",
    fill: "#FBC391"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.838 36.196c.4 1.096 2.122 2.833 3.74 2.833 1.56 0 3.078-1.395 3.609-2.833.204-.555-1.513-2.608-3.609-2.533-2.35-.108-3.934 2-3.74 2.533z",
    fill: "#343030",
    stroke: "#343030",
    strokeWidth: 0.609
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.932 33.484c2.059-.019 3.766 2.41 3.504 2.831 0 .525-1.536 2.482-2.213 2.528-.848.057-3.738-2.455-3.421-3.582.076-.589.483-1.761 2.13-1.777z",
    fill: "#4E4747",
    stroke: "#4E4747",
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.302 9.051C26.952 5.7 34.177-.23 33.883 2.87l-1.818 16.22L23.302 9.05z",
    fill: "#FBC391",
    stroke: "#DAA87C",
    strokeWidth: 3.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.557 44.189c6.147 0 11.13-4.983 11.13-11.13 0-6.147-4.983-11.13-11.13-11.13-6.147 0-11.13 4.983-11.13 11.13 0 6.147 4.983 11.13 11.13 11.13z",
    fill: "#FFCE3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.687 33.339c0 6.156-4.6 8.28-10.756 8.28-4.832 0-9.5-4.546-9.5-8.28 0-6.156 2.825-11.524 8.98-11.524 6.156 0 11.276 5.368 11.276 11.524z",
    fill: "#F7D160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.935 20.64v8.798c.437-.773.982-1.532 1.56-2.24a26.23 26.23 0 0 1 3.424-3.444c-1.004-.87-2.304-1.902-3.401-2.572-.652-.398-1.16-.621-1.467-.66a.515.515 0 0 0-.106-.004.548.548 0 0 0-.01.122z",
    fill: "#FF9B42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.955 20.49-.002.003m-.018.147v8.798c.437-.773.982-1.532 1.56-2.24a26.23 26.23 0 0 1 3.424-3.444c-1.004-.87-2.304-1.902-3.401-2.572-.652-.398-1.16-.621-1.467-.66a.515.515 0 0 0-.106-.004.548.548 0 0 0-.01.122z",
    stroke: "#FFCE3E",
    strokeWidth: 1.016
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.179 20.64v8.798a16.315 16.315 0 0 0-1.56-2.24 26.223 26.223 0 0 0-3.424-3.444c1.003-.87 2.304-1.902 3.4-2.572.653-.398 1.16-.621 1.467-.66a.514.514 0 0 1 .106-.004c.005.023.01.061.01.122z",
    fill: "#FF9B42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.158 20.49.002.003m.019.147v8.798a16.315 16.315 0 0 0-1.56-2.24 26.223 26.223 0 0 0-3.424-3.444c1.003-.87 2.304-1.902 3.4-2.572.653-.398 1.16-.621 1.467-.66a.514.514 0 0 1 .106-.004c.005.023.01.061.01.122z",
    stroke: "#F7D160",
    strokeWidth: 1.016
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.765 40.741c1.954.385 5.898 1.563 7.627 2.104M37.05 40.741c-1.954.385-5.898 1.563-7.627 2.104M41.798 40.233c2.628.023 8.037.467 10.412.686M37.015 40.233c-2.538.022-7.76.461-10.053.678M41.789 39.694c2.159-.467 6.686-1.042 8.68-1.27M37.117 39.694c-2.159-.467-6.687-1.042-8.68-1.27",
    stroke: "#000",
    strokeWidth: 0.223
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.858 42.373c.26-.207 1.822-2.066 1.517-2.314-.306-.248-3.69-.235-3.966 0-.238.203 1.113 2.084 1.385 2.314.224.188.804.206 1.064 0zM36.385 36.33c.83-3.586-4.016-4.673-4.47-2.362-.472 2.405 1.634 3.958 3.712 3.222.28-.1.48-.33.536-.392.058-.063.19-.33.222-.468zM42.183 36.33c-.83-3.586 4.016-4.673 4.47-2.362.473 2.405-1.633 3.958-3.711 3.222-.281-.1-.48-.33-.537-.392a1.628 1.628 0 0 1-.222-.468z",
    fill: "#372F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.113 32.846c-.2.22-.3 2.89-.037 3.265.33.468.925.448 1.456.276.36-.117.713-.279.815-.505.07-.157.087-.411.087-.68-.108-1.79-2.143-2.552-2.321-2.356z",
    fill: "#483F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.456 32.846c.2.22.3 2.89.037 3.265-.33.468-.925.448-1.456.276-.36-.117-.713-.279-.815-.505-.07-.157-.086-.411-.086-.68.107-1.79 2.142-2.552 2.32-2.356z",
    fill: "#504653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.354 35.246a.519.519 0 0 0 .504-.532.519.519 0 0 0-.504-.532.519.519 0 0 0-.504.532c0 .294.226.532.504.532zM43.215 35.246a.519.519 0 0 1-.504-.532c0-.294.226-.532.504-.532s.504.238.504.532a.519.519 0 0 1-.504.532z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.732 39.892c.046-.033 2.052-.065 2.677.144.175.419-1.184 2.109-1.492 2.223-.184.069-1.286-2.295-1.185-2.367z",
    fill: "#483F4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v45H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(26 20)",
    d: "M0 0h27.421v24.809H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimal);
export default __webpack_public_path__ + "static/media/animal.cb216c558381d47620ed2ca7a161014a.svg";
export { ForwardRef as ReactComponent };